<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-30 17:02:04
 * @LastEditors: geory
 * @LastEditTime: 2026-01-13 14:22:47
-->
<template>
  <div class="container">
    <menubar from="setting" />
    <div class="headRow">
      <!-- 建议反馈入口：与分段控件同一行的右侧 -->
      <div
        class="feedbackEntry"
        @click="openFeedbackDialog"
      >
        建议反馈
      </div>
      <!-- 分段控件：改为正常文档流，不再用负 top 绝对定位悬在内容区上方（会被裁掉） -->
      <div class="segment">
        <div
          :class="segIdx == 0 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          @click="segItemClick(0)"
        >
          基础设置
        </div>
        <div
          :class="segIdx == 1 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          @click="segItemClick(1)"
        >
          吸附设置
        </div>
        <div
          :class="segIdx == 2 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          @click="segItemClick(2)"
        >
          逐条发送
        </div>
        <div
          :class="segIdx == 3 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          :style="{ borderRight: 'none' }"
          @click="segItemClick(3)"
        >
          首页页签
        </div>
      </div>
    </div>
    <div class="mainView">
      <div
        v-if="segIdx == 0"
        class="tabContent radioCellGroup"
      >
        <div class="radioCell">
          <div class="radioCellL">话术显示行数：</div>
          <el-radio-group
            v-model="settingInfo.wenanShowLineCount"
            @change="updateSetting"
          >
            <el-radio :label="1">最多显示1行内容</el-radio>
            <el-radio :label="3">最多显示3行内容</el-radio>
            <el-radio :label="-1">全部显示</el-radio>
          </el-radio-group>
        </div>
        <div class="radioCell">
          <div class="radioCellL">标题颜色：</div>
          <div class="radioCellR">
            <div
              v-for="(item, idx) in colorArr"
              :key="item"
              class="colorRaidoItem"
              :style="{ 'background-color': item }"
              @click="colorIdx = idx"
            >
              <img
                v-if="idx == colorIdx"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092441.png"
              />
            </div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">话术详情：</div>
          <div
            class="radioCellR"
            @click="hoverPrviewChange"
          >
            <img
              class="radioCellRCheck"
              v-if="settingInfo && settingInfo.hoverPreviewCheck"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class="">鼠标停留3秒显示</div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">本地数据：</div>
          <div class="radioCellR">
            <el-button
              type="primary"
              size="small"
              @click="clearLocalData"
            >清理本地缓存</el-button>
            <el-button
              type="primary"
              size="small"
              @click="resetSettingInfo"
            >恢复默认设置</el-button>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">语音快捷键：</div>
          <div class="shortcutArea">
            <input
              class="shortcutInput"
              :class="{ shortcutRecording: isRecordingKey, shortcutSuccess: shortcutJustSet }"
              readonly
              :value="displayText"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              @click="onShortcutActivate"
              @keydown.enter.prevent="onShortcutActivate"
              @keydown.space.prevent="onShortcutActivate"
              @focus="onShortcutFocus"
              @blur="onShortcutBlur"
            />
            <div class="aiVoicePolishArea">
              <span class="aiVoicePolishLabel">AI语音优化</span>
              <el-switch
                v-model="settingInfo.aiVoicePolish"
                active-color="#ff4949"
                inactive-color="#ccc"
                @input="aiVoicePolishChange"
              >
              </el-switch>
            </div>
            <div
              v-if="shortcutError"
              class="shortcutError"
            >
              {{ shortcutError }}
            </div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">隐藏显示快捷键：</div>
          <div class="shortcutArea">
            <input
              class="shortcutInput"
              :class="{ shortcutRecording: isRecordingShowHideKey, shortcutSuccess: showHideShortcutJustSet }"
              readonly
              :value="displayShowHideText"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              @click="onShowHideActivate"
              @keydown="onShowHideKeydown"
              @focus="onShowHideFocus"
              @blur="onShowHideBlur"
            />
            <div
              v-if="showHideShortcutError"
              class="shortcutError"
            >
              {{ showHideShortcutError }}
            </div>
          </div>
        </div>
        <div
          v-if="cancelTopBtnShow"
          class="radioCell"
        >
          <div class="radioCellL">取消置顶：</div>
          <div
            class="radioCellR"
            @click="cancelTopChange"
          >
            <img
              class="radioCellRCheck"
              v-if="settingInfo && settingInfo.cancelTop"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class=""></div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">发送后隐藏：</div>
          <div
            class="radioCellR"
            @click="hideAfterSendChange"
          >
            <img
              class="radioCellRCheck"
              v-if="settingInfo && settingInfo.hideAfterSend"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class="">发送话术后自动最小化</div>
          </div>
        </div>
      </div>
      <div
        v-if="segIdx == 1"
        class="tabContent radioCellGroup"
      >
        <div class="radioCell">
          <div class="radioCellL">开启吸附：</div>
          <el-switch
            v-model="settingInfo.focusOpen"
            active-color="#ff4949"
            inactive-color="#ccc"
            @input="focusOpenChange"
          >
          </el-switch>
        </div>
        <div class="radioCell">
          <div class="radioCellL">开机自动启动：</div>
          <el-switch
            v-model="settingInfo.autoLaunch"
            active-color="#ff4949"
            inactive-color="#ccc"
            @input="autoLaunchChange"
          >
          </el-switch>
        </div>
        <div class="radioCell">
          <div class="radioCellL">列表吸附：</div>
          <el-radio-group
            v-model="settingInfo.adsorptionDirection"
            @change="updateSetting"
          >
            <el-radio :label="1">左侧</el-radio>
            <el-radio :label="2">右侧</el-radio>
          </el-radio-group>
        </div>
        <div
          class="radioCell radioCellFill"
        >
          <div class="radioCellL">吸附应用：</div>
          <div class="radioCellR">
            <div class="radioCellRT">
              <div class="radioCellRTL">应用</div>
              <div class="radioCellRTR">吸附状态</div>
            </div>
            <div class="radioCellRB">
              <div
                v-if="!settingInfo.focusOpen"
                class="radioCellRBCover"
                @click="focusCoverClick"
              ></div>
              <div class="radioCellRBList">
                <div
                  v-for="(app, index) in settingInfo.applist"
                  :key="app.bundleId || app.name"
                  class="radioCellRBItem"
                  @change="updateSetting"
                >
                  <div class="radioCellRBL">
                    <img
                      class="radioCellRBLL"
                      :src="app.icon"
                    />
                    <div
                      class="radioCellRBLR"
                      :title="app.name"
                    >{{ app.name }}</div>
                    <span
                      v-if="app.custom"
                      class="appDelBtn"
                      title="删除"
                      @click.stop="removeApp(index)"
                    >×</span>
                  </div>
                  <div class="radioCellRBR">
                    <el-radio-group v-model="app.focus">
                      <el-radio :label="true">启用</el-radio>
                      <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="radioCellRBAdd">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-plus"
                  :loading="adding"
                  @click="addApp"
                >添加应用</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="segIdx == 2"
        class="tabContent radioCellGroup"
      >
        <div class="radioCell">逐条发送(话术可选择)</div>
        <div class="radioCell radioCell2">分段设置</div>
        <div class="radioCell radioCell3">
          <div
            v-for="(item, idx) in settingInfo.partSplitType"
            :key="'partSplitType' + idx"
            class="radioCellR radioCellR2"
            @click="autoSendChange(idx)"
          >
            <img
              class="radioCellRCheck"
              v-if="item.checked"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class="">{{ item.name }}</div>
          </div>
        </div>
        <div class="sep"></div>
        <div class="radioCell radioCell2">间隔时间设置</div>
        <div class="radioCell radioCell4">
          <div class="autoSendTypeItem">
            <el-radio
              v-model="settingInfo.spaceTimeType"
              label="1"
              @change="updateSetting"
              >智能间隔时间(模拟打字速度)</el-radio
            >
            <div v-if="settingInfo.spaceTimeType == '1'">
              <el-select
                v-model="settingInfo.letterSpaceTime"
                placeholder="请选择"
                :style="{ width: '75px', margin: '0 10px' }"
                @change="updateSetting"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option> </el-select
              >秒/字<span
                v-if="settingInfo.letterSpaceTime == 0.1"
                :style="{ 'margin-left': '20px' }"
                >较快</span
              ><span
                v-else-if="settingInfo.letterSpaceTime == 0.5"
                :style="{ 'margin-left': '20px' }"
                >较慢</span
              >
            </div>
          </div>
          <div class="autoSendTypeItem">
            <el-radio
              v-model="settingInfo.spaceTimeType"
              label="2"
              @change="updateSetting"
              >自定义时间间隔(秒数)</el-radio
            >
            <div v-if="settingInfo.spaceTimeType == '2'">
              <el-input-number
                v-model="settingInfo.spaceTime"
                :min="1"
                size="small"
                label="描述文字"
                :style="{ 'margin-left': '50px' }"
                @change="updateSetting"
              ></el-input-number>
            </div>
          </div>
        </div>
      </div>
      <!-- 首页顶部页签：保留哪些 + 顺序 -->
      <div
        v-if="segIdx == 3"
        class="tabContent radioCellGroup"
      >
        <div class="radioCell">
          首页顶部页签（勾选要保留的，↑↓ 调整顺序）
        </div>
        <div class="homeTabList">
          <div
            v-for="(tab, idx) in homeTabList"
            :key="tab.key"
            class="homeTabItem"
            :class="{ homeTabItemOff: !tab.visible }"
          >
            <div
              class="homeTabCheck"
              :title="tab.visible ? '点击隐藏' : '点击显示'"
              @click="toggleHomeTab(tab)"
            >
              <img
                v-if="tab.visible"
                class="homeTabCheckIcon"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
              />
              <img
                v-else
                class="homeTabCheckIcon"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
              />
            </div>
            <div class="homeTabLabel">{{ tab.label }}</div>
            <div class="homeTabOps">
              <div
                class="homeTabOpBtn"
                :class="idx == 0 ? 'homeTabOpBtnDisabled' : ''"
                title="上移"
                @click="moveHomeTab(idx, -1)"
              >↑</div>
              <div
                class="homeTabOpBtn"
                :class="idx == homeTabList.length - 1 ? 'homeTabOpBtnDisabled' : ''"
                title="下移"
                @click="moveHomeTab(idx, 1)"
              >↓</div>
            </div>
          </div>
        </div>
        <div class="homeTabFooter">
          <el-button
            size="small"
            @click="resetHomeTabs"
          >恢复默认</el-button>
          <div class="homeTabTip">取消勾选后首页不再显示该页签；至少保留一个</div>
        </div>
      </div>
    </div>
    <!-- 建议反馈弹窗 -->
    <el-dialog
      title="建议反馈"
      :visible.sync="feedbackDialogShow"
      width="420px"
      custom-class="feedbackDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="feedbackForm">
        <div class="feedbackItem">
          <div class="feedbackLabel"><span class="feedbackStar">*</span>问题描述</div>
          <el-input
            v-model="feedbackForm.content"
            type="textarea"
            :rows="5"
            maxlength="500"
            show-word-limit
            resize="none"
            placeholder="请详细描述您遇到的问题或想要的功能建议"
          ></el-input>
        </div>
        <div class="feedbackItem">
          <div class="feedbackLabel"><span class="feedbackStar">*</span>联系方式</div>
          <el-input
            v-model="feedbackForm.contact"
            maxlength="50"
            placeholder="请留下手机号/微信/邮箱，方便我们回访"
          ></el-input>
        </div>
      </div>
      <div
        slot="footer"
        class="feedbackFooter"
      >
        <el-button
          size="small"
          @click="feedbackDialogShow = false"
        >取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="feedbackSubmitting"
          @click="submitFeedback"
        >提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MessageBox,
  Message,
  Radio,
  RadioGroup,
  Switch,
  Button,
  Select,
  Option,
  InputNumber,
  Dialog,
  Input,
} from "element-ui";
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);
Vue.use(Dialog);
Vue.use(Input);

import axios from "axios";
import menubar from "@/components/menubar";
import qiniuService from "@/service/qiniuService";
import {
  HOME_TOP_TAB_DEFAULTS,
  defaultHomeTabListWithVisible,
  defaultHomeTopTabKeys,
  normalizeHomeTopTabs,
  homeTabsFromSettingInfo,
  loadLocalHomeTopTabs,
  saveLocalHomeTopTabs,
  clearLocalHomeTopTabs,
} from "@/common/js/homeTopTabs";

// ── 设置云端同步 ──
// 服务端接口 /group/web/qiniu/getUpLoadKey.do：functionType=7（设置）、targetId=用户id
// 上传：用 mediaToken 的 qiniuToken/uploadKey 传到七牛 media 通道（同一个 key 覆盖式更新）
// 拉取：调用同一接口，用 mediaDomain + mediaToken.uploadKey 拼出读取地址
const SETTING_CLOUD_FUNCTION_TYPE = 7;
const SETTING_CLOUD_DATA_VERSION = 1;
const SETTING_CLOUD_RECORD_KEY = "wminput:settingCloudRecord"; // 本地同步记录：{userId, updateTime}
const SETTING_CLOUD_FILE_NAME = "wminput-setting.json";
const SETTING_CLOUD_PUSH_DEBOUNCE = 1500; // 连续修改设置时，上传防抖（毫秒）
const SETTING_CLOUD_LOGIN_POLL = 3000; // 未登录（新电脑首次安装）时轮询登录状态的间隔
const SETTING_CLOUD_LOGIN_POLL_MAX = 200; // 最多轮询次数（约 10 分钟）

export default {
  props: {
    from: {
      type: String,
    },
  },
  name: "Setting",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height:
        document.documentElement.clientHeight || document.body.clientHeight,
      segIdx: 0,
      adding: false,
      // wenanShowLineCount:0,
      colorArr: ["#FF6058", "#FFA000", "#43A046", "#69A3FB"],
      colorIdx: 0,
      adsorptionDirection: 1, //1左侧 2右侧
      // applist: [
      //   {
      //     name: "全部应用",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021152720.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "微信",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154220.png",
      //     focus: 1,
      //   },
      //   {
      //     name: "QQ",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154559.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "千牛",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154758.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "WhatsApp",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154831.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "Telegram",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154906.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "企业微信",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154936.png",
      //     focus: 2,
      //   },
      // ],
      settingInfo: {
        aiVoicePolish: true,
      },
      // 首页顶部页签配置（设置页「首页页签」）：全部页签按当前顺序排列，visible=false 表示不保留
      homeTabList: [],
      cancelTopBtnShow: false,
      isRecordingKey: false,
      shortcutJustSet: false, // 刚设置成功，绿色闪一下
      shortcutError: "",
      isRecordingShowHideKey: false,
      showHideShortcutJustSet: false, // 显示/隐藏快捷键刚设置成功，绿色闪一下
      showHideShortcutError: "",
      // letterSpaceTime: 0.5,
      options: [
        {
          value: 0.1,
          label: "0.1秒/字",
        },
        {
          value: 0.2,
          label: "0.2秒/字",
        },
        {
          value: 0.3,
          label: "0.3秒/字",
        },
        {
          value: 0.4,
          label: "0.4秒/字",
        },
        {
          value: 0.5,
          label: "0.5秒/字",
        },
      ],
      // spaceTimeType: "1", //1.智能间隔时间(模拟打字速度) 2.自定义时间间隔(秒数)
      // spaceTime: 1,
      // partSplitType: [],
      // 建议反馈
      feedbackDialogShow: false,
      feedbackSubmitting: false,
      feedbackForm: {
        content: "",
        contact: "",
      },
      // ── 设置云端同步状态 ──
      cloudSyncing: false, // 正在与云端对账（拉取 + 按需上传）
      cloudPushing: false, // 正在上传设置
      cloudPushPending: false, // 上传过程中设置又被修改 → 本次结束后补传一次
      cloudPushTimer: null, // 上传防抖定时器
      cloudPollTimer: null, // 未登录时的登录轮询定时器
      cloudSyncedUser: "", // 已同步过的用户id，避免同一用户重复触发
      cloudReady: false, // 本地设置已从客户端主进程取回（取回前禁止上传，防止默认值覆盖云端）
      cloudStarted: false, // 同步入口是否已启动（幂等）
    };
  },
  components: {
    menubar,
  },
  computed: {
    displayText() {
      if (this.isRecordingKey) return "请按键…";
      return this.settingInfo?.voiceShortcut || "Fn";
    },
    displayShowHideText() {
      if (this.isRecordingShowHideKey) return "请按键…";
      const isWin = /windows/i.test(navigator.userAgent || "");
      return this.formatAccelerator(
        this.settingInfo?.showHideShortcut || (isWin ? "Alt+Q" : "CommandOrControl+E")
      );
    },
  },
  watch: {
    colorIdx() {
      this.settingInfo.color = this.colorArr[this.colorIdx];
      this.updateSetting();
    },
    // letterSpaceTime() {
    //   this.settingInfo.letterSpaceTime = this.letterSpaceTime;
    //   this.updateSetting();
    // },
    // spaceTimeType() {
    //   this.settingInfo.spaceTimeType = this.spaceTimeType;
    //   this.updateSetting();
    // },
    // spaceTime() {
    //   this.settingInfo.spaceTime = this.spaceTime;
    //   this.updateSetting();
    // },
    // partSplitType() {
    //   this.settingInfo.partSplitType = this.partSplitType;
    //   this.updateSetting();
    // },
  },
  activated() {},
  created() {
    // this.settingInfo = JSON.parse(localStorage.getItem("settingInfo"));
    // this.colorIdx = 0;
    // return;

    console.log("settting created...");
    if (window.require) {
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("getSettingInfo");
      let _this = this;
      ipcRenderer.on("getSettingInfoResp", (event, settingInfo) => {
        console.log("getSettingInfoResp....");
        if (settingInfo) {
          console.log("settting getSettingInfoResp settingInfo:", settingInfo);
          _this.settingInfo = JSON.parse(settingInfo);
          // 旧版本升级：补上 voiceShortcut 默认值（用 $set 保证响应式）
          if (!_this.settingInfo.voiceShortcut) {
            _this.$set(_this.settingInfo, "voiceShortcut", "Fn");
          }
          if (!_this.settingInfo.showHideShortcut) {
            const isWin = /windows/i.test(navigator.userAgent || "");
            _this.$set(_this.settingInfo, "showHideShortcut", isWin ? "Alt+Q" : "CommandOrControl+E");
          }
          if (_this.settingInfo.aiVoicePolish === undefined) {
            _this.$set(_this.settingInfo, "aiVoicePolish", true);
          }
          // 旧版本升级：补上「发送后隐藏」默认值（不勾选）
          if (_this.settingInfo.hideAfterSend === undefined) {
            _this.$set(_this.settingInfo, "hideAfterSend", false);
          }
          if (_this.settingInfo && _this.settingInfo.version) {
            if (_this.isVersionLessThan("1.2.0", _this.settingInfo.version)) {
              _this.cancelTopBtnShow = true;
            }
          }
          _this.colorIdx = _this.colorArr.indexOf(_this.settingInfo.color);
          // 首页页签列表跟着设置项重建（设置项里没有这一项时内部会回退到本地缓存/默认）
          _this.syncHomeTabList();
          // _this.letterSpaceTime = _this.settingInfo.letterSpaceTime;
          // _this.spaceTimeType = _this.settingInfo.spaceTimeType;
          // _this.spaceTime = _this.settingInfo.spaceTime;
          // _this.timeSpace = _this.spaceTime * 1000;
          // _this.partSplitType = _this.settingInfo.partSplitType;
          // 本地设置就绪后再与云端同步（避免把尚未初始化的默认值上传覆盖云端）
          _this.onSettingReady();
        }
      });
      ipcRenderer.on("settingWinShow", (event, from) => {
        if (from == "autoSend") {
          this.segIdx = 2;
        } else {
          this.segIdx = 0;
        }
        // 打开设置页时与云端对一次账（云端较新则恢复云端设置）
        _this.syncSettingWithCloud();
      });
      // 其它窗口（主窗口登录 / 切换账号）写入 localStorage → 立即同步一次
      window.addEventListener("storage", (e) => {
        if (e && e.key && e.key !== "edujia:group:web:userid") return;
        const userId = _this.currentUserId();
        if (!userId || userId === _this.cloudSyncedUser) return;
        _this.syncSettingWithCloud();
      });
      // 引导页"快捷键设置" → 聚焦语音快捷键输入框
      ipcRenderer.on("setting-focus-shortcut", () => {
        this.$nextTick(() => {
          const el = this.$el.querySelector(".shortcutInput");
          if (el) el.focus();
        });
      });
      // 主进程检测到 Fn 键按下 → 录制 Fn 快捷键（不依赖合成键盘事件，回避 IME 问题）
      ipcRenderer.on("voice-shortcut-fn", () => {
        // 仅当快捷键录制区处于激活状态时才处理
        if (_this.isRecordingKey) {
          _this.setShortcut("Fn");
        }
      });
      // 主进程直接完成快捷键录制后通知 UI 更新
      ipcRenderer.on("shortcut-recorded", (_event, key) => {
        _this.isRecordingKey = false;
        _this.shortcutJustSet = true;
        _this.shortcutError = "";
        setTimeout(() => { _this.shortcutJustSet = false; }, 1500);
      });
      // 挂到 window 上供主进程 executeJavaScript 直接调用（备用路径）
      window.__setVoiceShortcut = (key) => {
        if (_this.isRecordingKey) {
          _this.setShortcut(key);
        }
      };
    }
  },
  methods: {
    isVersionLessThan(version, targetVersion) {
      // 将版本号拆分成主版本号、次版本号和修订号
      const [currentMajor, currentMinor, currentPatch] = version
        .split(".")
        .map(Number);
      const [targetMajor, targetMinor, targetPatch] = targetVersion
        .split(".")
        .map(Number);

      // 比较主版本号、次版本号和修订号
      if (currentMajor < targetMajor) {
        return true;
      } else if (currentMajor === targetMajor) {
        if (currentMinor < targetMinor) {
          return true;
        } else if (currentMinor === targetMinor) {
          return currentPatch < targetPatch;
        }
      }

      return false;
    },
    // 打开建议反馈弹窗（保留上次未提交的草稿）
    openFeedbackDialog() {
      this.feedbackDialogShow = true;
    },
    // 提交建议反馈
    async submitFeedback() {
      const content = (this.feedbackForm.content || "").trim();
      const contact = (this.feedbackForm.contact || "").trim();
      if (!content) {
        this.$message({ message: "请填写问题描述", type: "warning" });
        return;
      }
      // 接口文档中 contact 为必填
      if (!contact) {
        this.$message({ message: "请填写联系方式", type: "warning" });
        return;
      }
      if (this.feedbackSubmitting) return;
      this.feedbackSubmitting = true;
      try {
        const res = await this.$http.feedbackSubmit({ content, contact });
        if (res && res.code === 200) {
          this.feedbackDialogShow = false;
          this.feedbackForm.content = "";
          this.feedbackForm.contact = "";
          this.$message({
            message: "反馈提交成功，感谢您的建议！",
            type: "success",
          });
        }
        // 非 200 的提示由 request.js 的响应拦截器统一弹出，这里不重复提示；
        // 弹窗保持打开，避免用户已填写的内容丢失
      } catch (err) {
        // 打印真实原因：例如热更新只替换了本组件、$http 还是旧模块导致
        // feedbackSubmit 不存在时，只弹提示会让人误以为"点了没反应、没发请求"
        console.error("[feedback] 提交失败:", err);
        this.$message({ message: "反馈提交失败，请稍后重试", type: "error" });
      } finally {
        this.feedbackSubmitting = false;
      }
    },
    // 清理本地缓存：只清客户端里「设置页没有体现」的本机数据
    // （窗口位置与尺寸、剪贴板历史、备忘日历标题缓存等），设置项不受影响
    clearLocalData() {
      this.$confirm(
        "将清理窗口位置、剪贴板历史等本机缓存数据（设置项不受影响），清理后客户端会自动重启，是否继续?",
        "清理本地缓存",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("clearLocalData");
      });
    },
    // 恢复默认设置：交给客户端主进程把设置项重置为默认值（本机缓存不受影响），
    // 重置后再同步到服务端，避免换电脑登录后被云端的旧设置覆盖回来
    resetSettingInfo() {
      this.$confirm(
        "将把设置页所有选项恢复为默认值（窗口位置、剪贴板历史等本机缓存不受影响），是否继续?",
        "恢复默认设置",
        {
          confirmButtonText: "恢复默认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const { ipcRenderer } = window.require("electron");
            const res = await ipcRenderer.invoke("resetSettingInfo");
            if (!res || !res.ok) {
              this.$message({
                message: (res && res.message) || "恢复默认设置失败",
                type: "error",
              });
              return;
            }
            if (res.settingInfo) {
              this.settingInfo = JSON.parse(res.settingInfo);
              if (!this.settingInfo.voiceShortcut) {
                this.$set(this.settingInfo, "voiceShortcut", "Fn");
              }
              this.colorIdx = this.colorArr.indexOf(this.settingInfo.color);
              // 首页页签是「设置项 + 本地缓存」两份，主进程重置只认识设置项，
              // 这里显式把两份都恢复成默认（全部保留、默认顺序），否则历史本地顺序会继续生效
              clearLocalHomeTopTabs();
              this.$set(this.settingInfo, "homeTopTabs", defaultHomeTopTabKeys());
              this.rebuildHomeTabList();
              this.$store.commit("modifySettingInfo", this.settingInfo);
              ipcRenderer.send(
                "saveSettingInfo",
                JSON.stringify(this.settingInfo)
              );
            }
            this.$message({ message: "已恢复默认设置", type: "success" });
            this.pushLocalSettingToCloud();
          } catch (e) {
            console.error("[setting] 恢复默认设置失败:", e);
            this.$message({
              message: "恢复默认设置失败，请重试",
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    focusCoverClick() {
      this.$message({
        message: "请先开启吸附",
        type: "warning",
      });
    },
    focusOpenChange(checked) {
      this.settingInfo.focusOpen = checked;
      this.updateSetting();
    },
    async addApp() {
      if (!window.require || this.adding) return;
      this.adding = true;
      try {
        const { ipcRenderer } = window.require("electron");
        const info = await ipcRenderer.invoke("pickAppFile");
        // 用户取消选择：静默返回
        if (!info) return;
        // 主进程解析失败：明确提示
        if (info.error) {
          this.$message({ message: info.error, type: "error" });
          return;
        }
        if (!info.name || !(info.bundleId || info.path)) return;
        if (!Array.isArray(this.settingInfo.applist)) {
          this.settingInfo.applist = [];
        }
        // 去重：Mac 用 bundleId，Windows 用 exe 路径
        const key = info.bundleId || (info.path ? info.path.toLowerCase() : "");
        const exists = this.settingInfo.applist.some((a) => {
          const ak = a.bundleId || (a.path ? a.path.toLowerCase() : "");
          return !!(key && ak && ak === key);
        });
        if (exists) {
          this.$message({ message: "该应用已在列表中", type: "warning" });
          return;
        }
        this.settingInfo.applist.push({
          name: info.name,
          icon: info.icon || "",
          enName: info.name,
          focus: true,
          custom: true,
          bundleId: info.bundleId,
          path: info.path,
        });
        this.updateSetting();
      } catch (e) {
        this.$message({ message: "添加应用失败，请重试", type: "error" });
      } finally {
        this.adding = false;
      }
    },
    removeApp(index) {
      const app = this.settingInfo.applist && this.settingInfo.applist[index];
      if (!app || !app.custom) return;
      this.settingInfo.applist.splice(index, 1);
      this.updateSetting();
    },
    autoLaunchChange(checked) {
      this.settingInfo.autoLaunch = checked;
      this.updateSetting();
    },
    aiVoicePolishChange(checked) {
      this.settingInfo.aiVoicePolish = checked;
      this.updateSetting();
    },
    cancelTopChange() {
      this.settingInfo.cancelTop = !this.settingInfo.cancelTop;
      this.updateSetting();
    },
    // 发送后隐藏：勾选后点击话术/图片等发送完成会自动最小化软件
    hideAfterSendChange() {
      this.settingInfo.hideAfterSend = !this.settingInfo.hideAfterSend;
      this.updateSetting();
    },
    autoSendChange(itemIdx) {
      // this.partSplitType.forEach((item, idx) => {
      //   item.checked = idx === itemIdx;
      // });
      if (this.settingInfo.partSplitType[itemIdx].noCancel) {
        return;
      }
      this.settingInfo.partSplitType[itemIdx].checked = this.settingInfo
        .partSplitType[itemIdx].checked
        ? 0
        : 1;
      this.updateSetting();
    },
    hoverPrviewChange() {
      this.settingInfo.hoverPreviewCheck = !this.settingInfo.hoverPreviewCheck;
      this.updateSetting();
    },

    onShortcutActivate() {
      if (this.isRecordingKey) return;
      this.isRecordingKey = true;
      this.shortcutError = "";
      this.shortcutJustSet = false;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("shortcut-recording-state", true);
      } catch (_) {}
    },

    onShortcutFocus() {
      this.shortcutError = "";
      this.shortcutJustSet = false;
    },

    onShortcutBlur() {
      if (!this.isRecordingKey) return;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("shortcut-recording-state", false);
      } catch (_) {}
      setTimeout(() => {
        this.isRecordingKey = false;
        this.shortcutError = "";
        this.shortcutJustSet = false;
      }, 200);
    },

    setShortcut(key) {
      this.settingInfo.voiceShortcut = key;
      this.isRecordingKey = false;
      this.shortcutJustSet = true;
      this.shortcutError = "";
      this.updateSetting();
      // 1.5s 后恢复正常显示
      setTimeout(() => { this.shortcutJustSet = false; }, 1500);
    },

    // ── 显示/隐藏快捷键录制 ──
    onShowHideActivate() {
      if (this.isRecordingShowHideKey) return;
      this.isRecordingShowHideKey = true;
      this.showHideShortcutError = "";
      this.showHideShortcutJustSet = false;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("showhide-shortcut-recording", true);
      } catch (_) {}
    },

    onShowHideFocus() {
      this.showHideShortcutError = "";
      this.showHideShortcutJustSet = false;
    },

    onShowHideBlur() {
      if (!this.isRecordingShowHideKey) return;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("showhide-shortcut-recording", false);
      } catch (_) {}
      setTimeout(() => {
        this.isRecordingShowHideKey = false;
        this.showHideShortcutError = "";
        this.showHideShortcutJustSet = false;
      }, 200);
    },

    onShowHideKeydown(e) {
      if (!this.isRecordingShowHideKey) return;
      e.preventDefault();
      e.stopPropagation();

      const key = e.key;
      // 单独按下修饰键时继续等待主键
      if (["Meta", "Control", "Alt", "Shift", "CapsLock"].includes(key)) {
        return;
      }
      if (!e.metaKey && !e.ctrlKey && !e.altKey) {
        this.showHideShortcutError = "请按住 Cmd/Ctrl/Alt 再按其他键";
        return;
      }

      const keyName = this.toAcceleratorKey(key);
      if (!keyName) {
        this.showHideShortcutError = "不支持该按键，请换一个组合键";
        return;
      }

      const mods = [];
      if (e.metaKey) mods.push("Command");
      else if (e.ctrlKey) mods.push("Control");
      if (e.altKey) mods.push("Alt");
      if (e.shiftKey) mods.push("Shift");
      const accelerator = mods.concat(keyName).join("+");
      this.setShowHideShortcut(accelerator);
    },

    setShowHideShortcut(key) {
      this.settingInfo.showHideShortcut = key;
      this.isRecordingShowHideKey = false;
      this.showHideShortcutJustSet = true;
      this.showHideShortcutError = "";
      this.updateSetting();
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("showhide-shortcut-recording", false);
      } catch (_) {}
      // 1.5s 后恢复正常显示
      setTimeout(() => { this.showHideShortcutJustSet = false; }, 1500);
    },

    // 将浏览器 KeyboardEvent.key 转换为 Electron accelerator 键名
    toAcceleratorKey(key) {
      if (/^[a-zA-Z]$/.test(key)) return key.toUpperCase();
      if (/^[0-9]$/.test(key)) return key;
      if (/^F([1-9]|1[0-9]|2[0-4])$/i.test(key)) return key.toUpperCase();
      const map = {
        ArrowUp: "Up",
        ArrowDown: "Down",
        ArrowLeft: "Left",
        ArrowRight: "Right",
        " ": "Space",
        Enter: "Enter",
        Return: "Return",
        Tab: "Tab",
        Escape: "Esc",
        Backspace: "Backspace",
        Delete: "Delete",
        Home: "Home",
        End: "End",
        PageUp: "PageUp",
        PageDown: "PageDown",
      };
      return map[key] || "";
    },

    // 将 Electron accelerator 转成友好显示（Mac 用符号、Windows 用文字）
    formatAccelerator(acc) {
      if (!acc) return "";
      const isWin = /windows/i.test(navigator.userAgent || "");
      return acc
        .replace(/CommandOrControl/g, isWin ? "Ctrl" : "⌘")
        .replace(/Command/g, isWin ? "Win" : "⌘")
        .replace(/Control/g, "Ctrl")
        .replace(/Alt/g, isWin ? "Alt" : "⌥")
        .replace(/Option/g, isWin ? "Alt" : "⌥")
        .replace(/Shift/g, isWin ? "Shift" : "⇧")
        .replace(/\+/g, " ");
    },

    segItemClick(idx) {
      this.segIdx = idx;
      // 每次切到「首页页签」都按最新配置重建列表：
      // 首页长按拖动排序、云端恢复设置都可能在这中间改过配置
      if (idx === 3) this.syncHomeTabList();
    },

    // ───────────────────────── 首页顶部页签 ─────────────────────────
    // 「保留哪些 + 顺序」就是首页顶栏的渲染配置（见 common/js/homeTopTabs.js）：
    //   设置项 settingInfo.homeTopTabs 优先 → 老版本长按排序的本地缓存 → 默认（全部保留）
    currentHomeTabConfig() {
      const fromSetting = homeTabsFromSettingInfo(this.settingInfo);
      if (fromSetting) return fromSetting;
      const fromLocal = loadLocalHomeTopTabs();
      if (fromLocal) return fromLocal;
      return normalizeHomeTopTabs(null);
    },
    // 用当前配置重建设置页列表：保留的排前面并按配置顺序，被隐藏的按默认顺序接在后面
    syncHomeTabList() {
      if (!this.homeTabList.length || this.homeTabVisibleSig() !== this.homeTabConfigSig()) {
        this.rebuildHomeTabList();
      }
    },
    rebuildHomeTabList() {
      const visible = this.currentHomeTabConfig();
      const visibleKeys = visible.map((tab) => tab.key);
      const list = visible.map((tab) =>
        Object.assign({}, tab, { visible: true })
      );
      HOME_TOP_TAB_DEFAULTS.forEach((tab) => {
        if (visibleKeys.indexOf(tab.key) < 0) {
          list.push(Object.assign({}, tab, { visible: false }));
        }
      });
      this.homeTabList = list;
    },
    homeTabVisibleSig() {
      return this.homeTabList
        .filter((tab) => tab.visible)
        .map((tab) => tab.key)
        .join(",");
    },
    homeTabConfigSig() {
      return this.currentHomeTabConfig()
        .map((tab) => tab.key)
        .join(",");
    },
    // 勾选/排序后统一落盘：设置项（主进程持久化 + 广播 + 云端同步）+ 本地缓存兜底
    applyHomeTabList() {
      const visible = this.homeTabList.filter((tab) => tab.visible);
      const keys = normalizeHomeTopTabs(
        visible.map((tab) => tab.key)
      ).map((tab) => tab.key);
      saveLocalHomeTopTabs(keys);
      this.$set(this.settingInfo, "homeTopTabs", keys);
      this.updateSetting();
    },
    toggleHomeTab(tab) {
      if (tab.visible && this.homeTabList.filter((t) => t.visible).length <= 1) {
        this.$message({ message: "至少保留一个页签", type: "warning" });
        return;
      }
      tab.visible = !tab.visible;
      this.sortHomeTabList();
      this.applyHomeTabList();
    },
    moveHomeTab(idx, step) {
      const list = this.homeTabList.slice();
      const item = list[idx];
      if (!item) return;
      // 只在「同样是勾选/未勾选」的行之间交换：跟隐藏行换位置对配置没有任何影响，
      // 用户点了 ↑ 却什么都没发生（列表分区后正常情况下不会走到这里）
      let to = idx + step;
      while (to >= 0 && to < list.length && list[to].visible !== item.visible) to += step;
      if (to < 0 || to >= list.length) return;
      list.splice(idx, 1);
      list.splice(to, 0, item);
      this.homeTabList = list;
      this.applyHomeTabList();
    },
    // 列表始终「保留中的在前、已隐藏的在后」，↑↓ 交换到的必然是同一类行
    sortHomeTabList() {
      const visible = this.homeTabList.filter((tab) => tab.visible);
      const hidden = this.homeTabList.filter((tab) => !tab.visible);
      this.homeTabList = visible.concat(hidden);
    },
    resetHomeTabs() {
      this.homeTabList = defaultHomeTabListWithVisible();
      this.applyHomeTabList();
      this.$message({ message: "已恢复默认页签", type: "success" });
    },

    // ───────────────────────── 设置云端同步 ─────────────────────────
    // 需求：设置页的所有设置保存到服务端，换电脑登录后自动恢复，不用重新设置
    // 服务端只按 targetId（用户id）+ functionType=7（设置）下发 media 通道凭证：
    //   上传 → mediaToken.qiniuToken + mediaToken.uploadKey（同一个 key 覆盖式更新）
    //   拉取 → mediaDomain + mediaToken.uploadKey
    currentUserId() {
      return localStorage.getItem("edujia:group:web:userid") || "";
    },

    // 本地同步记录：{ userId, updateTime }
    getCloudRecord() {
      try {
        const obj = JSON.parse(
          localStorage.getItem(SETTING_CLOUD_RECORD_KEY) || "null"
        );
        if (obj && typeof obj === "object") {
          return {
            userId: obj.userId || "",
            updateTime: Number(obj.updateTime) || 0,
          };
        }
      } catch (e) {}
      return { userId: "", updateTime: 0 };
    },

    setCloudRecord(userId, updateTime) {
      try {
        localStorage.setItem(
          SETTING_CLOUD_RECORD_KEY,
          JSON.stringify({
            userId: userId || "",
            updateTime: Number(updateTime) || 0,
          })
        );
      } catch (e) {}
    },

    // getUpLoadKey.do 返回的 data 是加密串（兼容已是对象的情况）
    parseCloudToken(raw) {
      if (raw && typeof raw === "object") return raw;
      try {
        const key = localStorage.getItem("edujia:group:web:key") || undefined;
        return JSON.parse(this.$common.decrypt(raw, key));
      } catch (e) {
        this.cloudLog("[setting-cloud] 凭证解密失败: " + ((e && e.message) || e));
        return {};
      }
    },

    // 取设置文件的云凭证：uploadKey 固定 → 上传是覆盖、读取地址也是固定的
    // 按服务端要求：只传 functionType + targetId，不带任何 suffix 参数
    async fetchCloudKey() {
      const userId = this.currentUserId();
      if (!userId) throw new Error("未登录");
      const tokenParams = {
        functionType: SETTING_CLOUD_FUNCTION_TYPE,
        targetId: userId,
      };
      this.cloudLog(
        "[setting-cloud] → 请求上传凭证 " +
          this.cloudApiUrl("/group/web/qiniu/getUpLoadKey.do") +
          " 参数=" +
          JSON.stringify(tokenParams) +
          " 实际请求体(form)=" +
          this.cloudFormBody(tokenParams) +
          "（只传 functionType/targetId，无任何 suffix 参数）"
      );
      const enResp = await this.$http.getFileUploadToken(tokenParams);
      this.cloudLog(
        "[setting-cloud] ← 凭证返回 code=" +
          (enResp && enResp.code) +
          " message=" +
          (enResp && enResp.message) +
          " body=" +
          this.cloudBrief(enResp && enResp.data)
      );
      if (!enResp || enResp.code != 200) {
        const msg = (enResp && enResp.message) || "无返回";
        this.cloudLog(
          "[setting-cloud] ✖ 获取凭证失败: " +
            msg +
            "；本次请求体=" +
            this.cloudFormBody(tokenParams) +
            "（仅 functionType/targetId，未带 suffix）"
        );
        throw new Error("获取云凭证失败: " + msg);
      }
      const picked = this.pickCloudToken(enResp.data);
      if (!picked) throw new Error("云凭证里没有可用的 uploadKey");
      return Object.assign({ userId: userId }, picked);
    },

    // 日志用：本次请求实际发出去的表单体（qs.stringify 后的形态）
    cloudFormBody(params) {
      try {
        return new URLSearchParams(params).toString();
      } catch (e) {
        return "";
      }
    },

    // 从解密后的凭证里挑出可用的上传/读取凭证（服务端可能放在 mediaToken，也可能放 videoToken）
    pickCloudToken(rawData) {
      const object = (this.parseCloudToken(rawData) || {}).object || {};
      this.cloudLog(
        "[setting-cloud] 凭证解密后 mediaDomain=" +
          this.cloudBrief(object.mediaDomain) +
          " videoDomain=" +
          this.cloudBrief(object.videoDomain) +
          " imageDomain=" +
          this.cloudBrief(object.imageDomain) +
          " mediaToken=" +
          this.cloudBrief(object.mediaToken) +
          " videoToken=" +
          this.cloudBrief(object.videoToken) +
          " imageToken=" +
          this.cloudBrief(object.imageToken)
      );
      const groups = [
        {
          name: "mediaToken",
          list: object.mediaToken,
          domain: object.mediaDomain,
        },
        {
          name: "videoToken",
          list: object.videoToken,
          domain: object.videoDomain || object.mediaDomain,
        },
        {
          name: "imageToken",
          list: object.imageToken,
          domain: object.imageDomain || object.mediaDomain,
        },
      ];
      for (let i = 0; i < groups.length; i++) {
        const g = groups[i];
        const tk = (g.list || [])[0];
        if (!tk || !tk.uploadKey) continue;
        let domain = g.domain || "";
        if (domain && domain.charAt(domain.length - 1) !== "/") domain += "/";
        this.cloudLog(
          "[setting-cloud] 使用 " +
            g.name +
            "[0] uploadKey=" +
            tk.uploadKey +
            " 域名=" +
            domain
        );
        return {
          channel: g.name,
          saveKey: tk.uploadKey,
          qiniuToken: tk.qiniuToken,
          url: domain + tk.uploadKey,
        };
      }
      return null;
    },

    // 日志用：接口完整地址（生产环境 baseURL 为 "/"，即与页面同域）
    cloudApiUrl(path) {
      return (window.location && window.location.origin ? window.location.origin : "") + path;
    },

    // 统一日志出口：正式构建开了 terser 的 drop_console（console.log 会被删掉），
    // 走 window.console.log 才能保留下来，并会被客户端主进程转发到终端与
    // /tmp/wminput-boot.log（见 wsinputPc/main.js 里新增的 console-message 监听）
    cloudLog(text) {
      try {
        if (window.console && window.console.log) window.console.log(text);
      } catch (e) {}
    },

    // 日志用：转成不会刷屏的短字符串
    cloudBrief(data, max) {
      const limit = max || 800;
      let text;
      try {
        text = typeof data === "string" ? data : JSON.stringify(data);
      } catch (e) {
        text = String(data);
      }
      if (text === undefined || text === null) text = String(data);
      return text.length > limit
        ? text.slice(0, limit) + " …(共" + text.length + "字符)"
        : text;
    },

    // 拉取云端设置：返回 { updateTime, settingInfo }；云端还没有设置时返回 null
    // 网络异常 / 内容异常直接抛错，由调用方跳过本次同步（避免拿默认值覆盖云端）
    async pullCloudSetting() {
      const info = await this.fetchCloudKey();
      if (!info.url) throw new Error("云凭证缺少读取地址");
      const url =
        info.url +
        (info.url.indexOf("?") >= 0 ? "&" : "?") +
        "t=" +
        Date.now();
      this.cloudLog(
        "[setting-cloud] → 拉取云端设置 " +
          url +
          "（uploadKey=" +
          info.saveKey +
          "）"
      );
      const resp = await axios.get(url, {
        timeout: 15000,
        // 首次使用没有设置文件 → 404，不算错误
        validateStatus: () => true,
      });
      this.cloudLog(
        "[setting-cloud] ← 拉取返回 status=" +
          (resp && resp.status) +
          " body=" +
          this.cloudBrief(resp && resp.data)
      );
      if (!resp || resp.status !== 200) {
        this.cloudLog(
          "[setting-cloud] 云端暂无设置, status=" + (resp && resp.status)
        );
        return null;
      }
      let payload = resp.data;
      if (typeof payload === "string") {
        try {
          payload = JSON.parse(payload);
        } catch (e) {
          throw new Error("云端设置内容无法解析");
        }
      }
      if (!payload || !payload.settingInfo) {
        throw new Error("云端设置内容为空");
      }
      return {
        userId: payload.userId || info.userId,
        updateTime: Number(payload.updateTime) || 0,
        settingInfo: payload.settingInfo,
      };
    },

    // 上传本地设置（覆盖云端同一个 key）
    async pushCloudSetting(settingInfo, updateTime, userId) {
      const info = await this.fetchCloudKey();
      // version 是客户端版本号，不属于用户设置，不参与同步
      const data = Object.assign({}, settingInfo);
      delete data.version;
      const payload = {
        version: SETTING_CLOUD_DATA_VERSION,
        userId: userId || info.userId,
        updateTime: updateTime,
        settingInfo: data,
      };
      const file = new File([JSON.stringify(payload)], SETTING_CLOUD_FILE_NAME, {
        type: "application/json",
      });
      this.cloudLog(
        "[setting-cloud] → 上传设置 key=" +
          info.saveKey +
          " 文件=" +
          SETTING_CLOUD_FILE_NAME +
          " payload=" +
          this.cloudBrief(payload, 400)
      );
      const res = await qiniuService.uploadFile(file, {
        uploadKey: info.saveKey,
        qiniuToken: info.qiniuToken,
      });
      this.cloudLog(
        "[setting-cloud] ← 上传返回 key=" +
          (res && res.key) +
          " hash=" +
          (res && res.hash)
      );
      if (!res || !res.key) throw new Error("上传设置失败");
      return res.key;
    },

    // 本地设置从主进程取回后回调：启动一次同步（幂等）
    onSettingReady() {
      this.cloudReady = true;
      if (this.cloudStarted) return;
      this.cloudStarted = true;
      this.startCloudSync();
    },

    // 启动同步：已登录立即同步；未登录则轮询等登录（新电脑首次安装后账号登录）
    startCloudSync() {
      if (!window.require) return;
      if (this.currentUserId()) {
        this.syncSettingWithCloud();
        return;
      }
      if (this.cloudPollTimer) return;
      let tries = 0;
      this.cloudPollTimer = setInterval(() => {
        tries++;
        if (this.currentUserId()) {
          this.stopCloudLoginPoll();
          this.syncSettingWithCloud();
          return;
        }
        if (tries >= SETTING_CLOUD_LOGIN_POLL_MAX) this.stopCloudLoginPoll();
      }, SETTING_CLOUD_LOGIN_POLL);
    },

    stopCloudLoginPoll() {
      if (this.cloudPollTimer) {
        clearInterval(this.cloudPollTimer);
        this.cloudPollTimer = null;
      }
    },

    // 与云端对账：云端较新 → 拉取覆盖本地；本地较新 → 上传备份；一致 → 不处理
    async syncSettingWithCloud() {
      if (!window.require) return;
      if (!this.cloudReady) {
        this.cloudLog("[setting-cloud] 本地设置尚未就绪，跳过本次同步");
        return;
      }
      const userId = this.currentUserId();
      if (!userId) {
        this.cloudLog("[setting-cloud] 未登录，等登录后再同步");
        return;
      }
      if (this.cloudSyncing) {
        this.cloudLog("[setting-cloud] 上次同步还在进行，跳过本次");
        return;
      }
      this.cloudSyncing = true;
      try {
        const record = this.getCloudRecord();
        // 换账号后本地记录的时间戳不可比（按 0 处理）→ 云端优先
        const sameUser = record.userId === userId;
        const localUpdateTime = sameUser ? Number(record.updateTime) || 0 : 0;
        this.cloudLog(
          "[setting-cloud] 开始对账 userId=" +
            userId +
            " 本地记录=" +
            this.cloudBrief(record) +
            " 本地基准updateTime=" +
            localUpdateTime
        );
        let cloud = null;
        try {
          cloud = await this.pullCloudSetting();
        } catch (e) {
          // 状态未知：既不覆盖本地，也不用本地覆盖云端，等下次触发
          this.cloudLog("[setting-cloud] 拉取失败，跳过本次同步: " + ((e && e.message) || e));
          return;
        }
        if (cloud && cloud.updateTime > localUpdateTime) {
          this.applyCloudSetting(cloud);
          this.setCloudRecord(userId, cloud.updateTime);
          this.cloudSyncedUser = userId;
          this.$message({ message: "已同步云端设置", type: "success" });
          return;
        }
        if (cloud && cloud.updateTime === localUpdateTime) {
          this.cloudSyncedUser = userId;
          return; // 本地与云端一致
        }
        // 云端没有设置，且是刚切换过来的账号：不上传，避免把上个账号的设置写进新账号
        if (!cloud && record.userId && record.userId !== userId) {
          this.setCloudRecord(userId, 0);
          this.cloudSyncedUser = userId;
          return;
        }
        await this.pushLocalSettingToCloud();
        this.cloudSyncedUser = userId;
      } finally {
        this.cloudSyncing = false;
      }
    },

    // 上传本地设置：同一时刻只发一个请求，期间的新改动合并成一次补传
    async pushLocalSettingToCloud() {
      if (!window.require || !this.cloudReady) return;
      const userId = this.currentUserId();
      if (!userId) return;
      if (this.cloudPushing) {
        this.cloudPushPending = true;
        return;
      }
      this.cloudPushing = true;
      try {
        const updateTime = Date.now();
        await this.pushCloudSetting(this.settingInfo, updateTime, userId);
        this.setCloudRecord(userId, updateTime);
        this.cloudSyncedUser = userId;
        this.cloudLog(
          "[setting-cloud] 设置已保存到服务端, updateTime=" + updateTime
        );
      } catch (e) {
        this.cloudLog("[setting-cloud] 上传失败: " + ((e && e.message) || e));
      } finally {
        this.cloudPushing = false;
        if (this.cloudPushPending) {
          this.cloudPushPending = false;
          this.pushLocalSettingToCloud();
        }
      }
    },

    // 设置修改后的防抖上传：连续调整时只在停下来后上传一次
    scheduleCloudPush() {
      if (!window.require || !this.cloudReady || !this.currentUserId()) return;
      if (this.cloudPushTimer) clearTimeout(this.cloudPushTimer);
      this.cloudPushTimer = setTimeout(() => {
        this.cloudPushTimer = null;
        this.pushLocalSettingToCloud();
      }, SETTING_CLOUD_PUSH_DEBOUNCE);
    },

    // 用云端设置覆盖本地，并交给客户端主进程应用（快捷键、开机启动等即时生效）
    applyCloudSetting(cloud) {
      const cloudInfo = (cloud && cloud.settingInfo) || {};
      const localVersion = this.settingInfo && this.settingInfo.version;
      const merged = Object.assign({}, this.settingInfo, cloudInfo);
      // version 跟着本机客户端走，避免设置页按云端客户端版本判断按钮显隐
      if (localVersion) {
        merged.version = localVersion;
      } else {
        delete merged.version;
      }
      this.settingInfo = merged;
      // 旧版本升级兜底默认值
      if (!this.settingInfo.voiceShortcut) {
        this.$set(this.settingInfo, "voiceShortcut", "Fn");
      }
      if (!this.settingInfo.showHideShortcut) {
        const isWin = /windows/i.test(navigator.userAgent || "");
        this.$set(
          this.settingInfo,
          "showHideShortcut",
          isWin ? "Alt+Q" : "CommandOrControl+E"
        );
      }
      if (this.settingInfo.aiVoicePolish === undefined) {
        this.$set(this.settingInfo, "aiVoicePolish", true);
      }
      if (this.settingInfo.hideAfterSend === undefined) {
        this.$set(this.settingInfo, "hideAfterSend", false);
      }
      if (this.settingInfo.color) {
        this.colorIdx = this.colorArr.indexOf(this.settingInfo.color);
      }
      // 云端可能带着首页页签配置回来（换电脑登录），重建一次列表
      this.syncHomeTabList();
      this.$store.commit("modifySettingInfo", this.settingInfo);
      if (window.require) {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("saveSettingInfo", JSON.stringify(this.settingInfo));
      }
    },

    updateSetting() {
      // this.settingInfo.applist=this.applist;
      this.$store.commit("modifySettingInfo", this.settingInfo);
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("saveSettingInfo", JSON.stringify(this.settingInfo));
      // 同步到服务端（防抖）：换电脑登录后自动恢复
      this.scheduleCloudPush();
    },
  },
  beforeDestroy() {
    if (this.cloudPushTimer) clearTimeout(this.cloudPushTimer);
    this.cloudPushTimer = null;
    this.stopCloudLoginPoll();
  },
};
</script>
<style>
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
}

.el-radio {
  margin-right: 24px;
}

.el-radio__label {
  padding-left: 4px;
}

/* 建议反馈弹窗（custom-class 挂在 element-ui 弹窗根节点上，必须放在全局样式里） */
.feedbackDialog {
  border-radius: 8px;
}

.feedbackDialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e5e5e5;
}

.feedbackDialog .el-dialog__title {
  font-size: 14px;
  font-weight: bold;
  color: #3c3c3c;
}

.feedbackDialog .el-dialog__body {
  padding: 16px 20px 4px;
}

.feedbackDialog .el-dialog__footer {
  padding: 8px 20px 16px;
}
</style>
<style scoped>
.container {
  position: relative;
  /* 顶部 32px 给固定标题栏（topBar），下方留出头部行与内容区之间的间距 */
  padding-top: 40px;
  /* 整页与设置窗口等高，内容区自适应窗口高度，避免窗口变高后出现整页滚动 */
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 「分段控件 + 建议反馈」同一行：正常文档流，不再绝对定位浮在内容区上方。
   margin-bottom 保证与下方灰色内容区至少留 10px 间距 */
.headRow {
  flex: none;
  position: relative;
  height: 28px;
  margin: 8px 16px 10px;
}

/* 建议反馈入口：贴这一行右侧 */
.feedbackEntry {
  position: absolute;
  right: 0;
  top: 1px;
  z-index: 10;
  height: 26px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  color: #3c3c3c;
  background-color: #fff;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}

.feedbackEntry:hover {
  color: #096bff;
  border-color: #69a3fb;
}

/* 反馈弹窗内容区 */
.feedbackForm {
  font-size: 14px;
  color: #3c3c3c;
}

.feedbackItem {
  margin-bottom: 16px;
}

.feedbackLabel {
  margin-bottom: 8px;
  font-size: 13px;
  color: #3c3c3c;
}

.feedbackStar {
  margin-right: 4px;
  color: #ff4949;
}

.feedbackFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.mainView {
  width: calc(100vw - 20px);
  /* 内容区吃掉 headRow 以下的剩余高度 */
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  background-color: #e3e3e3;
  margin: 0 auto;
  padding-bottom: 20px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.segment {
  height: 26px;
  /* 正常文档流 + 左右 auto 居中（原来用 top:-34px 绝对定位悬在内容区上方，会被裁掉） */
  position: relative;
  margin: 0 auto;
  background-color: #e3e3e3;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  width: fit-content;
}

.segmentItem {
  width: 72px;
  height: 24px;
  background-color: #fff;
  background-image: unset;
  font-size: 12px;
  color: #3c3c3c;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #c1c1c1;
}

.segmentItemSel {
  background-image: linear-gradient(180deg, #69a3fb 0%, #096bff 100%);
  color: #fff;
}

.radioCellGroup {
  padding-top: 20px;
}

/* 各 tab 的内容区：占满设置窗口剩余高度，超高时在本区域内滚动。
   margin-top 抵消首个 radioCell 的 24px 上外边距，让「第一行到灰色区顶」恢复成
   原来（radioCellGroup padding-top 20px）的 20px 间距 */
.tabContent {
  flex: 1 1 auto;
  min-height: 0;
  margin-top: -24px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 4px;
}

.radioCell4 {
  display: block !important;
  margin-top: 0px !important;
}

.radioCell3 {
  flex-wrap: wrap;
  margin-top: 0px !important;
}

.radioCell2 {
  font-size: 14px;
  color: #808080;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.radioCell {
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-left: 82px;
}

.radioCellL {
  margin-right: 32px;
  width: 100px;
  text-align: right;
  white-space: nowrap;
}

.radioCellR2 {
  margin-right: 78px;
}

.radioCellR {
  display: flex;
  align-items: center;
}

/* 应用列表所在容器：表头 + 列表上下排列（原行内 display:block 的等价写法） */
.radioCellFill .radioCellR {
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
}

.radioCellRCheck {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.colorRaidoItem {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  margin-right: 23px;
  border: 2px solid #e3e3e3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.colorRaidoItem img {
  width: 18px;
  height: 18px;
  display: flex;
}

.radioCellRT {
  width: 100%;
  height: 32px;
  background-color: #fff;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.radioCellRTL {
  width: 180px;
  padding-left: 10px;
  font-size: 12px;
}

.radioCellRTR {
  width: 134px;
}

.radioCellRB {
  width: 324px;
  /* 保持原来的固定高度：窗口变高只多露出下方内容，不改列表高度 */
  height: 296px;
  background-color: #f4f4f4;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 表头左右两列沿用原布局（不继承下面列表行的 flex 布局） */
.radioCellRT .radioCellRBL {
  width: 180px;
  padding-left: 10px;
  font-size: 12px;
}

.radioCellRT .radioCellRBR {
  width: 134px;
}

.radioCellRBList {
  flex: 1;
  overflow-y: auto;
  padding-top: 16px;
}

.radioCellRBAdd {
  flex: none;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
}

.radioCellRBCover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 100;
  opacity: 0.8;
}

.radioCellRBItem {
  height: 32px;
  display: flex;
  margin-bottom: 8px;
}

.radioCellRBL {
  width: 180px;
  display: flex;
  align-items: center;
  position: relative;
}

.radioCellRBLL {
  width: 32px;
  height: 32px;
  margin-left: 16px;
  margin-right: 8px;
}

.radioCellRBLR {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #3c3c3c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appDelBtn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  line-height: 14px;
  text-align: center;
  border-radius: 8px;
  background-color: #e0e0e0;
  color: #666;
  font-size: 14px;
  cursor: pointer;
}

.appDelBtn:hover {
  background-color: #ff4949;
  color: #fff;
}

.radioCellRBR {
  width: 134px;
}

.sep {
  width: 74%;
  height: 1px;
  background-color: #c1c1c1;
  margin-top: 24px;
  margin-left: 13%;
}

/* ── 首页页签：勾选保留 + 上下调整顺序 ── */
.homeTabList {
  margin-left: 82px;
}

.homeTabItem {
  display: flex;
  align-items: center;
  width: 300px;
  height: 34px;
  margin-bottom: 8px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
}

.homeTabItemOff {
  background-color: #f4f4f4;
}

.homeTabCheck {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}

.homeTabCheckIcon {
  width: 16px;
  height: 16px;
}

.homeTabLabel {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #3c3c3c;
}

.homeTabItemOff .homeTabLabel {
  color: #999;
}

.homeTabOps {
  display: flex;
  align-items: center;
}

.homeTabOpBtn {
  width: 22px;
  height: 22px;
  margin-left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #3c3c3c;
  background-color: #fff;
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
}

.homeTabOpBtn:hover {
  color: #096bff;
  border-color: #69a3fb;
}

.homeTabOpBtnDisabled,
.homeTabOpBtnDisabled:hover {
  color: #c8c8c8;
  border-color: #e0e0e0;
  cursor: not-allowed;
}

.homeTabFooter {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 82px;
}

.homeTabTip {
  margin-left: 16px;
  font-size: 12px;
  color: #999;
}

.autoSendTypeItem {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.shortcutArea {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.aiVoicePolishArea {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.aiVoicePolishLabel {
  margin-right: 6px;
  font-size: 12px;
  color: #3c3c3c;
  white-space: nowrap;
}

.shortcutInput {
  width: 130px;
  height: 32px;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  background: #fff;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #3c3c3c;
  cursor: pointer;
  outline: none;
  user-select: none;
  font-family: inherit;
  padding: 0;
  box-sizing: content-box;
}

.shortcutInput:focus {
  outline: none;
}

.shortcutInput.shortcutRecording {
  border-color: #096bff;
  box-shadow: 0 0 0 2px rgba(9, 107, 255, 0.2);
  animation: shortcutPulse 1.2s ease-in-out infinite;
}

@keyframes shortcutPulse {
  0%, 100% { box-shadow: 0 0 0 2px rgba(9, 107, 255, 0.2); }
  50%      { box-shadow: 0 0 0 4px rgba(9, 107, 255, 0.1); }
}

.shortcutHint {
  width: 100%;
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  margin-left: 4px;
}

.shortcutError {
  width: 100%;
  font-size: 12px;
  color: #f56c6c;
  margin-top: 4px;
  margin-left: 4px;
}

.shortcutSuccess {
  border-color: #67c23a !important;
  box-shadow: 0 0 0 2px rgba(103, 194, 58, 0.25) !important;
  animation: none !important;
}

.shortcutSuccess::after {
  content: " ✓";
  color: #67c23a;
  font-weight: bold;
}
</style>
